import api from './client';

// GoCardless Bank Account Data API
export const gocardlessAPI = {
  saveCredentials: (secretId, secretKey) => api.post('/admin/integrations/gocardless/credentials', {
    secret_id: secretId, secret_key: secretKey,
  }),
  getInstitutions: (country) => api.get('/integrations/gocardless/institutions', { params: { country: country || 'fr' } }),
  connect: (institutionId, origin) => api.post('/integrations/gocardless/connect', null, {
    params: { institution_id: institutionId, origin },
  }),
  getStatus: () => api.get('/integrations/gocardless/status'),
  // Presence-only check (never returns the secrets themselves).
  getCredentialsStatus: () => api.get('/admin/diagnostics/gocardless-credentials-status'),
  sync: (connectionId) => api.post(`/integrations/gocardless/sync/${connectionId}`),
  getSyncRunStatus: (runId) => api.get(`/integrations/gocardless/sync/${runId}`),
  disconnect: (connectionId) => api.delete(`/integrations/gocardless/disconnect/${connectionId}`),
  reconnect: (connectionId, origin) => api.post(`/integrations/gocardless/reconnect/${connectionId}`, null, {
    params: { origin },
  }),
};
